/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListOrdersOptions, ListOrdersResponses } from '../types/ListOrders'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List all orders
 * {@link /v1/orders}
 */
export function listOrders<ThrowOnError extends boolean = true>(
  options: Options<ListOrdersOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListOrdersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/orders',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      styles: {
        query: {
          order_book_id: { style: 'form', explode: true },
          kind: { style: 'form', explode: true },
          status: { style: 'form', explode: true },
        },
      },
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListOrdersResponses, ThrowOnError>>,
  )
}
